import { Routes } from '@angular/router';
import { ForgotPassword } from '../authentication/forgot-password/forgot-password';
import { Signin } from '../authentication/signin/signin';
import { UpdatePassword } from '../authentication/update-password/update-password';
import { Dashboard } from '../pages/dashboard/dashboard';
import { ManageMenuPage } from '../pages/master/manage-menu/manage-menu';
import { ManageRolePage } from '../pages/master/manage-role/manage-role';
import { ManageUserPage } from '../pages/master/manage-user/manage-user';
import { authGuard } from '../helper/guards/auth-guard';
import { AuditLogsPage } from '../pages/master/audit-logs/audit-logs';
import { BatchIntegrationPage } from '../pages/ssc/batch-integration/batch-integration';
import { LanguageAssetsPage } from '../pages/ssc/language-assets/language-assets';
import { ModelBenchmarkPage } from '../pages/ssc/model-benchmark/model-benchmark';
import { QualityDashboardPage } from '../pages/ssc/quality-dashboard/quality-dashboard';
import { SecurityAuditPage } from '../pages/ssc/security-audit/security-audit';
import { TranslationWorkspacePage } from '../pages/ssc/translation-workspace/translation-workspace';
import { ConfigurationPortal } from '../pages/portal-settings/configuration-portal/configuration-portal';

export const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'signin' },
    { path: 'signin', pathMatch: 'full', component: Signin },
    { path: 'forgot-password', pathMatch: 'full', component: ForgotPassword },
    { path: 'update-password', pathMatch: 'full', component: UpdatePassword },
    { path: 'dashboard', pathMatch: 'full', component: Dashboard, canActivate: [authGuard] },
    { path: 'translation-workspace', pathMatch: 'full', component: TranslationWorkspacePage, canActivate: [authGuard] },
    { path: 'model-benchmark', pathMatch: 'full', component: ModelBenchmarkPage, canActivate: [authGuard] },
    { path: 'language-assets', pathMatch: 'full', component: LanguageAssetsPage, canActivate: [authGuard] },
    { path: 'batch-integration', pathMatch: 'full', component: BatchIntegrationPage, canActivate: [authGuard] },
    { path: 'quality-dashboard', pathMatch: 'full', component: QualityDashboardPage, canActivate: [authGuard] },
    { path: 'security-audit', pathMatch: 'full', component: SecurityAuditPage, canActivate: [authGuard] },
    { path: 'configuration-portal', pathMatch: 'full', component: ConfigurationPortal, canActivate: [authGuard] },
    { path: 'menus', pathMatch: 'full', component: ManageMenuPage, canActivate: [authGuard] },
    { path: 'admin/manage-user', pathMatch: 'full', component: ManageUserPage, canActivate: [authGuard] },
    { path: 'admin/manage-role', pathMatch: 'full', component: ManageRolePage, canActivate: [authGuard] },
    { path: 'admin/audit-logs', pathMatch: 'full', component: AuditLogsPage, canActivate: [authGuard] },
    { path: '**', redirectTo: 'signin' },
];
